import React from "react";
import { connect } from "react-redux";
import numeral from "numeral";

import classes from "./DataOverview.module.scss";
import truckIcon from "./../../../../assets/icons/truck.png";
import roadIcon from "./../../../../assets/icons/road.png";
import peopleIcon from "./../../../../assets/icons/people.png";
import DataOverviewItem from "./DataOverviewItem/DataOverviewItem";

const DataOverview = (props) => {
  return (
    <div className={classes.wrapper}>
      <DataOverviewItem
        img={truckIcon}
        value={numeral(props.vehicleCount).format("0,0")}
        metric={"TOTAL VEHICLES"}
        color="#ff903b"
      />
      <DataOverviewItem
        img={roadIcon}
        value={numeral(props.totalMilesDriven).format("0,0")}
        metric={"MILES DRIVEN"}
        color="#47b9ff"
      />
      <DataOverviewItem
        img={peopleIcon}
        value={numeral(props.totalImpressions).format("0,0")}
        metric={"IMPRESSIONS"}
        color="#008f28"
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    vehicleCount: state.clientDashboard.analytics.vehicleCount,
    totalMilesDriven: state.clientDashboard.analytics.totalMilesDriven,
    totalImpressions: state.clientDashboard.analytics.totalImpressions
  };
};

export default connect(mapStateToProps)(DataOverview);
